module.exports = {"451324100":"金秀镇","451324101":"桐木镇","451324102":"头排镇","451324200":"三角乡","451324201":"忠良乡","451324202":"罗香乡","451324203":"长垌乡","451324204":"大樟乡","451324205":"六巷乡","451324207":"三江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451324.json
// module id = 2303
// module chunks = 0